// Keeps the optional pack add-on summary in sync with its checkbox and the product form quantity.
// s-product-form adds the checked input[data-lines] (main product + add-on) as two cart lines.
// Prices shown here are display-only; the automatic discount applies the real pack price in cart and checkout.
class SPackAddon extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const form = this.closest('form');

    this.addEventListener('change', () => this.#sync(), opts);
    form?.addEventListener('input', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.name === 'quantity') this.#sync();
    }, opts);
    form?.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.name === 'quantity') this.#sync();
    }, opts);
    form?.addEventListener('s-quantity:change', () => this.#sync(), opts);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #quantity() {
    const input = this.closest('form')?.elements.namedItem('quantity');
    const value = Number.parseInt(input instanceof HTMLInputElement ? input.value : '1', 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  #sync() {
    const checkbox = this.querySelector('input[data-pack-addon]');
    const checked = checkbox instanceof HTMLInputElement && checkbox.checked && !checkbox.disabled;
    const qty = this.#quantity();
    const main = Number(this.dataset.mainPrice || 0) * qty;
    const addonRegular = Number(this.dataset.addonPrice || 0) * qty;
    const addonPack = Number(this.dataset.packPrice || 0) * qty;
    const total = main + (checked ? addonPack : 0);

    this.querySelectorAll('[data-pack-qty]').forEach((node) => { node.textContent = String(qty); });
    this.#set('[data-pack-main]', this.#money(main));
    this.#set('[data-pack-addon-regular]', this.#money(addonRegular));
    this.#set('[data-pack-addon-price]', this.#money(addonPack));
    this.#set('[data-pack-savings]', this.#money(addonRegular - addonPack));
    this.#set('[data-pack-total]', this.#money(total));

    for (const selector of ['[data-pack-badge]', '[data-pack-addon-row]', '[data-pack-savings-row]']) {
      const node = this.querySelector(selector);
      if (node instanceof HTMLElement) node.hidden = !checked;
    }
  }

  #set(selector, text) {
    const node = this.querySelector(selector);
    if (node) node.textContent = text;
  }

  #money(cents) {
    const format = this.dataset.moneyFormat || '${{amount_no_decimals}}';
    const group = (value, separator) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    const units = Math.round(cents) / 100;
    const whole = Math.floor(units);
    const decimals = (units - whole).toFixed(2).slice(2);
    const values = {
      amount: `${group(whole, ',')}.${decimals}`,
      amount_no_decimals: group(whole, ','),
      amount_with_comma_separator: `${group(whole, '.')},${decimals}`,
      amount_no_decimals_with_comma_separator: group(whole, '.'),
      amount_with_apostrophe_separator: `${group(whole, "'")}.${decimals}`,
      amount_no_decimals_with_space_separator: group(whole, ' '),
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => values[key] ?? match);
  }
}

if (!customElements.get('s-pack-addon')) {
  customElements.define('s-pack-addon', SPackAddon);
}
